import { render, staticRenderFns } from "./FigmaVectorLayer.vue?vue&type=template&id=9644eb2a&scoped=true"
import script from "./FigmaVectorLayer.vue?vue&type=script&lang=js"
export * from "./FigmaVectorLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9644eb2a",
  null
  
)

export default component.exports